export default "__VITE_ASSET__D$NW5T7g__"